module.exports = __webpack_public_path__ + "img/auth-bg1.0de44379.png";